// src/components/layout/ViewLoading.tsx
// Suspense fallback shown while a lazy-loaded route chunk downloads.
export default function ViewLoading() {
  return (
    <div className="flex-1 flex items-center justify-center h-full">
      <div className="text-[var(--om-text-dim)] text-xs">Loading...</div>
    </div>
  );
}
